<template>
    <div>
        <!-- SINGLE RESPONSE POPUP -->
        <el-dialog :visible.sync="showSingleResponsePopup" :center="true" :width="widthModal()"
                   @close="handleCloseFeedback()">
            <div v-if="stepSendAnswer == 1">
                <div v-if="generalPopup !== null" class="d-flex justify-content-center flex-column text-center text-bat mt-4"
                     style="word-break: normal">
                    <div>
                        <h5 class="mb-3 text-start text-title-bat">{{ generalPopup.popup_name }}</h5>
                    </div>
                    <div v-if="generalPopup.video !== null">
                        <div class="embed-responsive embed-responsive-16by9" style="width:100%;">
                            <iframe class="embed-responsive-item mb-2"
                                    :src="generalPopup.video + '&color=410978&autoplay=1&title=0&byline=0&portrait=0&autopause=0&muted=1&controls=1'"
                                    style="width:100%;" frameborder="0" allow="autoplay; fullscreen; picture-in-picture"
                                    allowfullscreen>
                            </iframe>
                        </div>
                    </div>
                    <div v-else-if="generalPopup.image != null">
                        <img :src="url_media + generalPopup.image" :alt="generalPopup.legal_popup_name"
                             class="mb-3 w-75 rounded-1">
                    </div>

                    <div>
                        <h5 class="mb-3 text-start text-title-bat">{{ generalPopup.statement }}</h5>
                        <p class="fs-6 text-start text-bat" style="height: 100%">{{ generalPopup.description }}</p>
                    </div>

                    <div v-if="generalPopup.popup_type_id === 1">
                        <el-radio-group v-model="answer"
                                        class="d-flex flex-column justify-content-start text-start mt-3">
                            <el-radio v-for="option in options" :key="answer.id" class="mb-2 w-full"
                                      :label="option.answer">{{ option.answer }}</el-radio>
                        </el-radio-group>
                    </div>
                    <div v-else-if="generalPopup.popup_type_id === 2">
                        <div class="question">
                            <label class="boxLabel">Escribe tu respuesta</label>
                            <el-input type="textarea" :rows="2" :autofocus="true" v-model="answer" class="boxInput">
                            </el-input>
                        </div>
                    </div>
                </div>

                <span slot="footer" class="dialog-footer"
                      v-if="generalPopup !== null && generalPopup.popup_type_id !== 3">
                    <el-button v-if="loading === 0" type="primary"
                               class="w-full w-100 p-3 btn-popups text-title-bat mt-3"
                               @click="sendGeneralAnswer">Enviar</el-button>
                    <el-button v-else type="primary" class="w-full w-100 p-3 btn-popups mt-3" disabled><i
                        class="fa-solid fa-spinner fa-spin-pulse"></i> Enviando</el-button>
                </span>
            </div>
            <div v-else>
                <h5 class="mb-3 text-start text-title-bat">Retroalimentación</h5>
                <div v-if="generalPopup.statement && generalPopup.statement != null">
                    <h5 class="mb-3 text-start text-bat">{{ generalPopup.statement }}</h5>
                    <h5 class="text-bat text-center"> {{ answer }} </h5>
                    <p class="text-bat text-center">
                        Respuesta:
                        <strong class="text-bat">{{ (answer && options.find(option => option.answer === answer &&
                            option.is_correct === 1)) ? 'Correcta' : 'Incorrecta' }}
                        </strong>
                    </p>
                </div>
            </div>
        </el-dialog>

        <!-- MULTIPLE RESPONSE POPUP -->
        <el-dialog :visible.sync="showMultipleResponsePopup" :center="true" :width="widthModal()"
                   @close="handleCloseFeedback()">
            <div v-if="stepSendAnswer == 1">
                <div v-if="generalPopup !== null" class="d-flex justify-content-center flex-column text-center text-bat mt-4"
                     style="word-break: normal">

                    <div>
                        <h5 class="mb-3 text-start text-title-bat">{{ generalPopup.popup_name }}</h5>
                    </div>

                    <div v-if="generalPopup.video !== null">
                        <div class="embed-responsive embed-responsive-16by9" style="width:100%;">
                            <iframe class="embed-responsive-item mb-2"
                                    :src="generalPopup.video + '&color=410978&autoplay=1&title=0&byline=0&portrait=0&autopause=0&muted=1&controls=1'"
                                    style="width:100%;" frameborder="0" allow="autoplay; fullscreen; picture-in-picture"
                                    allowfullscreen>
                            </iframe>
                        </div>
                    </div>

                    <div v-else-if="generalPopup.image != null">
                        <img :src="url_media + generalPopup.image" :alt="generalPopup.legal_popup_name"
                             class="mb-3 w-75 rounded-3">
                    </div>
                    <div>
                        <h5 class="mb-3 text-start text-title-bat">{{ generalPopup.statement }}</h5>
                        <p class="fs-6 text-start text-bat" style="height: 100%">{{ generalPopup.description }}</p>
                    </div>
                    <div v-if="generalPopup.popup_type_id === 3">
                        <div v-for="option in options" :key="answer.id"
                             class="form-check justify-content-start text-start">
                            <input class="form-check-input" type="checkbox" :value="false" id="flexCheckDefault"
                                   @change="handleCheckboxChange(option, $event)">
                            <label class="form-check-label" for="flexCheckDefault">{{ option.answer }}</label>
                        </div>
                    </div>
                </div>

                <span slot="footer" class="dialog-footer" v-if="generalPopup !== null">
                    <el-button v-if="loading === 0" type="primary"
                               class="w-full btnBlue w-100 p-3 btn-popups text-title-bat mt-3"
                               @click="sendGeneralAnswer">Enviar</el-button>
                    <el-button v-else type="primary" class="w-full w-100 p-3 btn-popups mt-3" disabled><i
                        class="fa-solid fa-spinner fa-spin-pulse"></i> Enviando</el-button>
                </span>
            </div>
            <div v-else>
                <h5 class="mb-3 text-start text-title-bat">Retroalimentación</h5>
                <div v-if="generalPopup.statement != null">
                    <h5 class="mb-3 text-start text-bat">{{ generalPopup.statement }}</h5>
                </div>

                <div>
                    <ul class="p-0 d-flex flex-column align-items-center">
                        <strong>Respuestas seleccionadas:</strong>

                        <li v-for="option in selectedOptions()" :key="option.id" :class="{
                            'check1': option.is_correct === 1 ,
                            'check2-multi': option.is_correct === 0 }">
                            <h5 class="text-bat">{{ option.answer }}</h5>
                        </li>
                    </ul>
                    <p v-if="areAllSelectedOptionsCorrect()" class="d-grid justify-content-center options-correct">
                        <strong>¡Acertaste todas las respuestas!</strong>
                    </p>
                    <p v-else-if="!areAllSelectedOptionsCorrect() && isAnyOptionIncorrect()"
                       class="d-grid justify-content-center check2">
                        <strong>Sigue intentando</strong>
                    </p>
                    <p v-else class="d-grid justify-content-center">
                        <strong>¡Acertaste todas las respuestas!</strong>
                    </p>
                    <p class="d-grid justify-content-center">
                        <strong>Respuestas correctas:</strong>
                        <ul>
                            <li v-for="option in options" :key="option.id" v-if="option.is_correct === 1" class="text-bat check1">
                                {{ option.answer }}
                            </li>
                        </ul>
                    </p>
                </div>
            </div>
        </el-dialog>

        <!-- LEGAL POPUP -->
        <el-dialog :visible.sync="showLegalPopup" :center="true"
                   :close-on-press-escape="legalPopup !== null && legalPopup.legal_popup_behavior_id === 2 ? false : true"
                   :show-close="legalPopup !== null && legalPopup.legal_popup_behavior_id === 2 ? false : true"
                   :close-on-click-modal="legalPopup !== null && legalPopup.legal_popup_behavior_id === 2 ? false : true"
                   :width="widthModal()">
            <div v-if="legalPopup" style="word-break: normal"
                 class="d-flex justify-content-center flex-column text-center text-bat mt-4">
                <div v-if="legalPopup.video !== null">
                    <div class="embed-responsive embed-responsive-16by9" style="width:100%;">
                        <iframe class="embed-responsive-item mb-2"
                                :src="legalPopup.video + '&color=410978&autoplay=1&title=0&byline=0&portrait=0&autopause=0&muted=1&controls=1'"
                                style="width:100%;" frameborder="0" allow="autoplay; fullscreen; picture-in-picture"
                                allowfullscreen>
                        </iframe>
                    </div>
                </div>
                <div v-else-if="legalPopup.image != null" class="d-flex justify-content-center text-center">
                    <img :src="url_media + legalPopup.image" :alt="legalPopup.legal_popup_name"
                         class="mb-3 w-75 rounded-1">
                </div>
                <div class="d-flex justify-content-center flex-column text-start">
                    <h6 class="mb-3 text-title-bat">{{ legalPopup.statement }}</h6>
                    <p style="height: 100%" class="text-bat">{{ legalPopup.description }}</p>
                    <p class="text-start text-legal" v-html="legalPopup.content"></p>
                    <div v-if="legalPopup.file">
                        <a target="_blank" :href="legalPopup.file" class="text-bat">Leer aquí documento legal</a>
                        <p class="text-bat">Al aceptar esta información legal estás de acuerdo con el contenido del
                            archivo legal anexo.
                        </p>
                    </div>
                </div>
                <div class="overflow-hidden" v-if="legalPopup.require_sign">
                    <p><strong>Agregar firma</strong></p>
                    <vue-drawing-canvas ref="VueCanvasDrawing" :image.sync="sign" height="200" width="280"
                                        :lineWidth="1" :styles="{ border: 'solid 1px #000', }" saveAs="png" />
                    <br><button type="button" class="btn btn-sm mb-2" style="background-color: #6c757d; color: white"
                                @click.prevent="$refs.VueCanvasDrawing.reset()">Limpiar firma</button>
                </div>
            </div>
            <div v-if="signEmptyError" class="bg-danger text-white p-2">La firma es requerida</div>
            <span slot="footer" class="dialog-footer text-bat">
                <div class="row">
                    <div class="col-6">
                        <el-button @click="sendLegalAnswer(false)"
                                   class=" w-100 p-3 mx-0 text-title-bat">Rechazar</el-button>
                    </div>
                    <div class="col-6">
                        <el-button type="primary" @click="sendLegalAnswer(true)"
                                   class="w-full btnBlue w-100 p-3 btn-popups text-title-bat">Aceptar</el-button>
                    </div>
                </div>
            </span>
        </el-dialog>

        <!-- SURVEY POPUP -->
        <el-dialog :visible.sync="showInitialStepSurveyPopup" :center="true" :width="widthModal()"
                   style="width: 75% !important; z-index: 2001; margin: 147px auto 50px !important;" class="dialog-mobile">
            <div v-if="surveyPopup !== null"
                 class="d-flex flex-column justify-content-center align-items-center text-center mt-4"
                 style="word-break: normal">

                <img class="img-victoria-tour mb-2" src="/img/victoria-tour.png" alt="victoria-tour">
                <div v-if="surveyPopup.points_to_win > 0 && isLinked">
                    <h5 class="text-title-bat">
                        ¡Participa en nuestra encuesta y
                    </h5>
                    <h5 class="text-title-bat">
                        consigue
                        <span class="btn-points d-inline-flex">
                            {{ surveyPopup.points_to_win !== null ? surveyPopup.points_to_win : '' }} Puntos
                        </span>
                        al instante!
                    </h5>
                </div>
                <div v-else>
                    <h5 class="text-title-bat">
                        ¡Participa en nuestra encuesta!
                    </h5>
                </div>
                <div class="col-12">
                    <span slot="footer" class="dialog-footer">
                        <el-button type="primary" class="w-full w-100 p-3 btn-popups mt-3 text-title-bat mt-4"
                                   @click="handleCloseInitialStepSurveyPopup()">Iniciar</el-button>
                    </span>
                </div>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="showSurveyPopup" :center="true" :width="widthModal()">
            <div v-if="surveyPopup !== null" class="d-flex justify-content-center flex-column text-center text-bat mt-4"
                 style="word-break: normal">
                <survey-question @close-parent-popup="handleClosePopup" :survey="surveyPopup" :is_popup="true"
                                 :show_header="false"></survey-question>
            </div>
        </el-dialog>

        <!-- VIDEO POPUP -->
        <el-dialog :visible.sync="showNewVideoPopup" :center="true" :destroy-on-close="true" :width="widthModal()"
                   :before-close="sendGeneralAnswer">
            <div v-if="videoPopup !== null" style="padding:56.25% 0 0 0;position:relative;" id="modal-video-container" class="mt-4">
                <iframe
                    :src="videoPopup.video + '&color=410978&autoplay=1&title=0&byline=0&portrait=0&autopause=0&muted=1&controls=1'"
                    style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0"
                    allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
            </div>
        </el-dialog>

        <!-- NEW VIDEO POPUP WITH CONTENT -->
        <el-dialog :visible.sync="showVideoPopup" :center="true" :show-close="true" :width="widthModal()" id="new-video-popup-container">
            <div v-if="videoPopup !== null" class="new-video-popup-content">
                <div class="modal-video-container-new">
                    <iframe
                        :src="videoPopup.video + '&color=410978&autoplay=1&title=0&byline=0&portrait=0&autopause=0&muted=1&controls=1'"
                        frameborder="0"
                        allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
                </div>
                <div class="new-video-popup-body">
                    <h2 class="new-video-popup-title" >{{ videoPopup.popup_name }}</h2>

                    <p class="new-video-popup-text" >{{ videoPopup.description }}</p>

                    <el-button type="primary" class="new-video-popup-button" @click="sendGeneralAnswer">
                        {{ videoPopup.button_text ?? 'Entendido' }}
                    </el-button>
                </div>
            </div>
        </el-dialog>

        <!-- VIDEO AD -->
        <el-dialog :visible.sync="showVideoAd" :center="true" :destroy-on-close="true"
                   :width="$mq === 'sm' ? '90%' : '40%'">
            <div v-if="videoAd !== null" style="padding:56.25% 0 0 0;position:relative;" id="modal-video-container" class="mt-4">
                <iframe
                    :src="videoAd.link + '&color=410978&autoplay=1&title=0&byline=0&portrait=0&autopause=0&muted=1&controls=1'"
                    style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0"
                    allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
            </div>
        </el-dialog>

        <!-- INFORMATION POPUP -->
        <el-dialog :visible.sync="showInformationPopup" :center="true" :width="widthModal()"
                   :before-close="sendGeneralAnswer">
            <div v-if="informationPopup && informationPopup.video !== null">
                <div class="embed-responsive embed-responsive-16by9" style="width:100%;">
                    <iframe class="embed-responsive-item my-2"
                            :src="informationPopup.video + '&color=410978&autoplay=1&title=0&byline=0&portrait=0&autopause=0&muted=1&controls=1'"
                            style="width:100%;" frameborder="0" allow="autoplay; fullscreen; picture-in-picture"
                            allowfullscreen>
                    </iframe>
                </div>
            </div>
            <div v-else-if="informationPopup && informationPopup.image != null">
                <img :src="url_media + informationPopup.image" :alt="informationPopup.popup_name" class="mb-3 w-75 rounded-1">
            </div>

            <div v-if="informationPopup" class="mt-4">
                <h5 v-if="informationPopup.statement" class="mb-3 text-title-bat">{{ informationPopup.statement }}</h5>
                <p v-if="informationPopup.content" class="fs-6 text-bat" style="height: 100%">{{ informationPopup.content }}</p>
            </div>

            <span slot="footer" class="dialog-footer" v-if="informationPopup && informationPopup.link_see_more">
                <el-button type="primary" class="w-full w-100 p-3 btn-popups text-title-bat" @click="sendGeneralAnswer">Ver más información</el-button>
            </span>
        </el-dialog>

        <!-- DATA UPDATE POPUP -->
        <el-dialog :visible.sync="showDataUpdatePopup" :center="true" :width="widthModal()">
            <div v-if="dataUpdatePopup" class="mt-4">

                <div v-if="dataUpdatePopup.video !== null">
                    <div class="embed-responsive embed-responsive-16by9" style="width:100%;">
                        <iframe class="embed-responsive-item my-2"
                                :src="dataUpdatePopup.video + '&color=410978&autoplay=1&title=0&byline=0&portrait=0&autopause=0&muted=1&controls=1'"
                                style="width:100%;" frameborder="0" allow="autoplay; fullscreen; picture-in-picture"
                                allowfullscreen>
                        </iframe>
                    </div>
                </div>
                <div v-else-if="dataUpdatePopup.image != null">
                    <img :src="url_media + dataUpdatePopup.image" :alt="dataUpdatePopup.popup_name"
                         class="mb-3 w-75 rounded-1">
                </div>

                <div v-if="stepDataUpdate == 1">
                    <div>
                        <h5 v-if="dataUpdatePopup.statement" class="mb-3 text-title-bat">{{ dataUpdatePopup.statement }}
                        </h5>
                        <p v-if="dataUpdatePopup.description" class="fs-6 text-bat" style="height: 100%">{{
                                dataUpdatePopup.description }}</p>
                        <div class="form-survey mb-3">
                            <form action="d-flex flex-column">
                                <div class="form-group mb-3">
                                    <label for="email" style="width:26%;" class="">Correo electrónico</label>
                                    <input v-model="email" type="email" class="form-control border border-ligh"
                                           name="email" id="email">
                                    <span v-if="errors && errors.email" class="error text-danger" for="email">{{
                                            errors.email[0]
                                        }}</span>
                                </div>
                                <div class="form-group mb-3">
                                    <label for="cellphone" style="width:15%;" class="">Celular</label>
                                    <input v-model="cellphone" type="text" class="form-control border border-ligh"
                                           name="cellphone" id="cellphone">
                                    <span v-if="errors && errors.cellphone" class="error text-danger" for="cellphone">{{
                                            errors.cellphone[0] }}</span>
                                </div>
                            </form>
                        </div>
                    </div>
                    <span slot="footer" class="row dialog-footer">
                        <!-- <div class="col-6">
                            <el-button @click="sendLegalAnswer(false)" class=" w-100 p-3 mx-0">¡Mis datos están bien!</el-button>
                        </div> -->
                        <div class="col-12">
                            <el-button type="primary" @click="validateDataUpdatePopup()"
                                       class=" w-full w-100 p-3 btn-popups text-title-bat">Siguiente</el-button>
                        </div>
                    </span>
                </div>
                <div v-else>
                    <div>
                        <h5 class="mb-3 text-title-bat">Por favor confirma los datos siguientes a enviar:</h5>
                        <p class="fs-6 text-bat" style="height: 100%">Celular
                            <span> <strong class="text-bat d-flex"> {{ cellphone }} </strong></span>
                        </p>
                        <p class="fs-6" style="height: 100%">Correo electrónico <span>
                                <strong class="text-bat d-flex">{{ email }}</strong>
                            </span></p>
                    </div>

                    <span slot="footer" class="row dialog-footer">
                        <div class="col-6">
                            <el-button @click="stepDataUpdate = 1" class=" w-100 p-3 mx-0 text-title-bat ">
                                Volver</el-button>
                        </div>
                        <div class="col-6">
                            <el-button type="primary" @click="sendDataUpdatePopup()"
                                       class="w-full w-100 p-3 btn-popups text-title-bat">Actualizar</el-button>
                        </div>
                    </span>
                </div>

                <!-- <span slot="footer" class="row dialog-footer">
                    <div class="col-6">
                        <el-button @click="sendLegalAnswer(false)" class=" w-100 p-3 mx-0">Volver</el-button>
                    </div>
                    <div class="col-6">
                        <el-button type="primary" @click="validateDataUpdatePopup()" class="btnBlue w-100 p-3 border border-0">Actualizar</el-button>
                    </div>
                </span> -->
            </div>
        </el-dialog>

        <!-- promo -->
        <el-dialog :visible.sync="showPromoPopup" :center="true" :width="widthModal()" id="promo-popup-container">
            <div v-if="promoPopup && promoPopup.image != null" class="promo-image-container">
                <img :src="promoPopup.image" :alt="promoPopup.popup_name" class="img-fluid">
            </div>

            <span slot="footer" class="dialog-footer" v-if="promoPopup">
                <el-button type="primary" class="btn-promo-action" @click="sendGeneralAnswer">
                    {{ promoPopup.button_text || 'Entendido' }}
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import VueDrawingCanvas from "vue-drawing-canvas";
import {EventBus} from "../../app";

export default {
    components: {
        VueDrawingCanvas,
    },
    props: {
        url_media: {
            default: '',
        },
    },
    data() {
        return {
            loading: 0,
            videoAd: null,
            legalPopup: null,
            videoPopup: null,
            informationPopup: null,
            dataUpdatePopup: null,
            generalPopup: null,
            surveyPopup: null,
            promoPopup: null,
            options: null,
            answersMultipleResponsePopup: [],
            validatedAnswer: false,
            stepDataUpdate: 1,
            stepSendAnswer: 1,
            email: '',
            cellphone: '',
            survey: null,
            show_survey: false,
            answer: '',
            showSingleResponsePopup: false,
            showMultipleResponsePopup: false,
            showVideoAd: false,
            showVideoPopup: false,
            showNewVideoPopup: false,
            showLegalPopup: false,
            showSurveyPopup: false,
            showInitialStepSurveyPopup: false,
            showInformationPopup: false,
            showDataUpdatePopup: false,
            showPromoPopup: false,
            sign: '',
            signEmptyError: false,

            isLinked: false,

            errors: null,
        }
    },
    mounted() {
        // const tourComplete = localStorage.getItem('tour_completed');
        // if (tourComplete == 'true') {
        //     this.loadQuestion()
        //     this.getDataUpdatePopup()
        // }
        this.loadQuestion();
        this.validateLinkingDate();
    },
    methods: {
        handleClosePopup() {
            this.showSurveyPopup = false;
        },
        handleCloseInitialStepSurveyPopup() {
            this.showSurveyPopup = true;
            this.showInitialStepSurveyPopup = false;
        },
        handleCloseFeedback() {
            if (this.stepSendAnswer == 2) {
                EventBus.$emit('refresh-points', true);
            }
        },
        selectedOptions() {
            return this.options.filter(option => this.answersMultipleResponsePopup.includes(option.id));
        },
        areAllSelectedOptionsCorrect() {
            return this.selectedOptions().every(option => option.is_correct === 1);
        },
        isAnyOptionIncorrect() {
            return this.selectedOptions().some(option => option.is_correct === 0);
        },
        /*  isOptionMarkedCorrect(optionId) {
             const option = this.options.find(opt => opt.id === optionId);
             return (
                 (option && option.is_correct === 1 && this.answersMultipleResponsePopup.includes(optionId)) ||
                 (option && option.is_correct === 0 && !this.answersMultipleResponsePopup.includes(optionId)) ||
                 (option && option.is_correct === 1 && !this.answersMultipleResponsePopup.includes(optionId))
             );
         }, */
        handleCheckboxChange(option, event) {
            let expectedAnswers = [];
            let sortedAnswersMultipleResponsePopup = [];
            let sortedExpectedAnswers = [];
            const isChecked = event.target.checked;
            if (isChecked === true) {
                this.answersMultipleResponsePopup.push(option.id);
            } else {
                this.answersMultipleResponsePopup = this.answersMultipleResponsePopup.filter(item => item !== option.id)
            }

            expectedAnswers = this.options.filter(item => item.is_correct === 1).map(item => item.id);

            sortedAnswersMultipleResponsePopup = this.answersMultipleResponsePopup.slice().sort();
            sortedExpectedAnswers = expectedAnswers.slice().sort();

            if (this.compareDataArrays(sortedAnswersMultipleResponsePopup, sortedExpectedAnswers)) {
                // console.log('Respuesta correcta');
                this.validatedAnswer = true;
            } else {
                // console.log('Respuesta incorrecta');
                this.validatedAnswer = false;
            }

            this.answer = sortedAnswersMultipleResponsePopup.join();
        },
        compareDataArrays(arr1, arr2) {
            return arr1.length === arr2.length && arr1.every((value, index) => value === arr2[index]);
        },
        getDataUpdatePopup() {
            this.loading++
            axios.get(`get-data-update-popup`)
                .then(({ data }) => {
                    this.cellphone = data.cellphone
                    this.email = data.email
                    // this.showDataUpdatePopup = true
                    this.loading--
                })
        },
        loadQuestion() {
            const tourComplete = localStorage.getItem('tour_completed');
            this.loading++
            axios.get(`get-popups`)
                .then(({ data }) => {
                    // console.log(data);
                    // console.log(data.survey_popup.length > 0);
                    if (data.legalPopup && data.legalPopup.length > 0) {
                        this.legalPopup = data.legalPopup[0]
                        this.showLegalPopup = true
                    } else if (data.popup && data.popup.length > 0) {
                        this.generalPopup = data.popup[0]
                        if (this.generalPopup && this.generalPopup.popup_type_id === 3) {
                            this.options = data.answers
                            this.showMultipleResponsePopup = true
                        } else {
                            this.options = data.answers
                            this.showSingleResponsePopup = true
                        }
                    } else if (data.informationPopup && data.informationPopup.length > 0) {
                        this.informationPopup = data.informationPopup[0]
                        this.showInformationPopup = true
                    } else if (data.dataUpdatePopup && data.dataUpdatePopup.length > 0) {
                        this.dataUpdatePopup = data.dataUpdatePopup[0]
                        this.showDataUpdatePopup = true
                    } else if (data.survey_popup && data.survey_popup.length > 0) {
                        console.log(this.surveyPopup);
                        this.surveyPopup = data.survey_popup[0]
                        this.showInitialStepSurveyPopup = true
                        //this.showSurveyPopup = true
                    } else if (data.videoPopup && data.videoPopup.length > 0) {
                        this.videoPopup = data.videoPopup[0]
                        if (this.videoPopup.video != null) {
                            this.showVideoPopup = true
                        }
                    } else if (data.ad_video && data.ad_video.length > 0) {
                        this.videoAd = data.ad_video
                        this.showVideoAd = true
                    } else if (data.promoPopup && data.promoPopup.length > 0) {
                        this.promoPopup = data.promoPopup[0]
                        this.showPromoPopup = true
                    }
                    this.loading--
                })
        },
        sendLegalAnswer(answer) {
            this.loading++
            if (this.legalPopup.require_sign) {
                if (this.$refs.VueCanvasDrawing.isEmpty() && answer === true) {
                    this.signEmptyError = true
                } else {
                    this.signEmptyError = false
                    var dataSend = {
                        "response": answer,
                        "legal_popup_id": this.legalPopup.id,
                        "sign": this.sign,
                    }
                }
            } else {
                var dataSend = {
                    "response": answer,
                    "legal_popup_id": this.legalPopup.id,
                }
            }

            let msgResponse = ''
            if (this.signEmptyError === false) {
                axios.post('/legal-popups/send', dataSend).then(
                    ({ data }) => {
                        if (data.status === 'log_out') {
                            this.showLegalPopup = false
                            setTimeout(() => {
                                window.location.href = '/'
                            }, 2500)
                        } else if (data.status === 'success') {
                            if (answer === true) {
                                msgResponse = (this.legalPopup && this.legalPopup.approval_message && this.legalPopup.approval_message !== null) ? this.legalPopup.approval_message : 'Has aceptado el acuerdo legal'
                                this.feedbackNotification('Aceptado', msgResponse, 'success')
                                setTimeout(function () {
                                    this.showLegalPopup = false
                                }, 5000);
                            } else {
                                msgResponse = (this.legalPopup && this.legalPopup.disapproval_message && this.legalPopup.disapproval_message !== null) ? this.legalPopup.disapproval_message : 'Has rechazado el acuerdo legal'
                                this.feedbackNotification('Rechazado', msgResponse, 'warning')
                            }

                            if (this.legalPopup.require_sign) {
                                this.$refs.VueCanvasDrawing.reset()
                            }

                            this.showLegalPopup = false

                            // setInterval(() => {
                            //     this.showLegalPopup = false
                            // }, 5000)

                            // this.loadQuestion()
                        } else if (data.status === 'error') {
                            console.log(data.error);
                        }
                        this.legalPopup = null
                        this.loading--

                    })
            }

        },
        sendGeneralAnswer(e) {
            this.loading++

            if (this.informationPopup || this.promoPopup) {
                this.answer = 'Visto';
            }

            if (this.videoPopup) {
                this.answer = 'Visto';
                this.showVideoPopup = false;

                let dataSend = {
                    "answer": this.answer,
                    "popup_id": this.videoPopup.id,
                    "validatedAnswer": this.validatedAnswer
                };

                axios.post('/answers/send', dataSend).then(({ data }) => {
                    if (data.status === 'success') {
                        if(this.videoPopup.link_see_more !== ''){
                            if (this.videoPopup.link_see_more.startsWith('http://') || this.videoPopup.link_see_more.startsWith('https://')) {
                                window.open(this.videoPopup.link_see_more, '_blank');
                            } else {
                                window.open(this.videoPopup.link_see_more, '_self');
                            }
                        }
                    }
                }).catch(error => {
                    console.error('Error al enviar respuesta "Visto":', error);
                });

                this.loading--;
                return;
            }

            if (this.generalPopup && (this.generalPopup.popup_type_id === 3 || this.generalPopup.popup_type_id === 1)) {
                this.stepSendAnswer = 2;
            }
            let dataSend = {
                "answer": this.answer,
                "popup_id": this.generalPopup ? this.generalPopup.id : (this.videoPopup ? this.videoPopup.id : (this.informationPopup ? this.informationPopup.id : this.promoPopup.id)),
                "validatedAnswer": this.validatedAnswer
            }

            let event = (typeof e.target === 'undefined') ? 'NO BUTTON' : (e && e.target && e.target.tagName && (e.target.tagName == 'BUTTON' || e.target.tagName == 'SPAN')) ? 'BUTTON OR SPAN CLICK' : ''

            let msgResponse = ''
            axios.post('/answers/send', dataSend).then(
                ({ data }) => {
                    if (data.status === 'wrong') {
                        if (!this.showVideoPopup) {
                            msgResponse = (this.generalPopup && this.generalPopup.disapproval_message && this.generalPopup.disapproval_message !== null)
                                ? this.generalPopup.disapproval_message
                                : 'Gracias por participar!'

                            this.feedbackNotification('Respuesta errada', msgResponse, 'warning')

                        }

                        setInterval(() => {
                            // this.showSingleResponsePopup = false
                            //this.showMultipleResponsePopup = false
                            // this.generalPopup = null
                            // this.loadQuestion()
                        }, 5000)

                    } else if (data.status === 'success') {

                        if (!this.showVideoPopup && !this.showInformationPopup && !this.showPromoPopup) {
                            msgResponse = (this.generalPopup && this.generalPopup.approval_message && this.generalPopup.approval_message !== null)
                                ? this.generalPopup.approval_message
                                : (this.generalPopup && this.generalPopup.assign_points === 1 && this.generalPopup.points_to_win > 0)
                                    ? 'Gracias por tu respuesta!. ¡Ganaste ' + this.generalPopup.points_to_win + ' puntos!'
                                    : 'Gracias por tu respuesta!'

                            this.feedbackNotification('Aceptado', msgResponse, 'success')
                        }

                        setInterval(() => {
                            // this.showSingleResponsePopup = false
                            // this.showMultipleResponsePopup = false
                            // this.generalPopup = null
                            if (!this.showVideoPopup) {
                                this.showVideoPopup = false
                                this.videoPopup = null
                            }
                            // this.answer = ''
                            // this.loadQuestion()
                        }, 5000)

                        if (this.showInformationPopup) {
                            if(this.informationPopup.link_see_more !== null && this.informationPopup.link_see_more !== '' && event === 'BUTTON OR SPAN CLICK') {
                                this.redirectSeeMore()
                            }
                            this.showInformationPopup = false
                        } else if (this.showPromoPopup) {
                            if(this.promoPopup.link_see_more !== null && this.promoPopup.link_see_more !== '' && event === 'BUTTON OR SPAN CLICK') {
                                if (this.promoPopup.link_see_more.startsWith('http://') || this.promoPopup.link_see_more.startsWith('https://')) {
                                    window.open(this.promoPopup.link_see_more, '_blank');
                                } else {
                                    window.open(this.promoPopup.link_see_more, '_self');
                                }
                            }
                            this.showPromoPopup = false
                        } else if (this.showMultipleResponsePopup) {
                            if (!this.showMultipleResponsePopup) {
                                EventBus.$emit('refresh-points', true);
                            }
                        } else if (this.showSingleResponsePopup) {
                            if (!this.showSingleResponsePopup) {
                                EventBus.$emit('refresh-points', true);
                            }
                        } else {
                            EventBus.$emit('refresh-points', true);
                        }
                    } else if (data.status === 'error') {
                        if (!this.showVideoPopup) {
                            this.feedbackNotification('Error', 'No pudimos procesar tu respuesta', 'error')

                        }
                        this.showSingleResponsePopup = false
                        this.showMultipleResponsePopup = false
                        console.log(data.error);
                    }
                    this.loading--
                })
        },

        validateDataUpdatePopup() {
            this.loading++
            let dataSend = {
                "cellphone": this.cellphone,
                "email": this.email,
            }

            axios.post('/data-update-popup/validate', dataSend).then(
                ({ data }) => {
                    console.log(data);
                    this.stepDataUpdate = 2
                    // if(data.status === 'success'){
                    //     this.feedbackNotification('Actualizado', 'Tus datos han sido actualizados', 'success')
                    //     this.showDataUpdatePopup = false
                    //     this.loading--
                    // }else if(data.status === 'error'){
                    //     this.feedbackNotification('Error', 'No pudimos procesar tu respuesta', 'error')
                    //     this.showDataUpdatePopup = false
                    //     console.log(data.error);
                    //     this.loading--
                    // }

                    this.errors = null
                }).catch((error) => {
                if (error && error.response && error.response.data && error.response.data.errors) {
                    console.log(error.response.data.errors)
                    this.errors = error.response.data.errors
                }
                this.stepDataUpdate = 1
                this.loading--
            })
        },
        sendDataUpdatePopup() {
            this.loading++
            let dataSend = {
                "cellphone": this.cellphone,
                "email": this.email,
                "popup_id": this.dataUpdatePopup ? this.dataUpdatePopup.id : null,
            }

            let msgResponse = ''
            axios.post('/data-update-popup/send', dataSend).then(
                ({ data }) => {
                    msgResponse = (this.dataUpdatePopup && this.dataUpdatePopup.approval_message && this.dataUpdatePopup.approval_message !== null)
                        ? this.dataUpdatePopup.approval_message
                        : '¡Tus datos han sido actualizados!'

                    this.feedbackNotification('Actualizado', msgResponse, 'success')
                    this.showDataUpdatePopup = false
                    EventBus.$emit('refresh-points', true);
                    this.loading--
                }).catch((error) => {
                msgResponse = (this.dataUpdatePopup && this.dataUpdatePopup.disapproval_message && this.dataUpdatePopup.disapproval_message !== null)
                    ? this.dataUpdatePopup.disapproval_message
                    : 'No pudimos procesar tu respuesta'

                this.feedbackNotification('Error', 'No pudimos procesar tu respuesta', 'error')
                this.showDataUpdatePopup = false
                this.loading--
            })
        },

        redirectSeeMore() {
            window.open(this.informationPopup.link_see_more, '_blank')
        },
        feedbackNotification(title, message, type) {
            this.$notify({
                title: title,
                message: message,
                type: type
            });
        },
        widthModal() {
            let width = '90%'
            if (this.$mq === 'md') {
                width = '60%'
            } else if (this.$mq === 'lg') {
                width = '50%'
            } else if (this.$mq === 'xl') {
                width = '30%'
            }
            return width
        },
        validateLinkingDate(){
            axios
                .get(`/validate-linking-date`)
                .then(({ data }) => {
                    this.isLinked = data.is_linked;
                })
                .catch(error => {
                    console.error('Error al obtener el estado de vinculación al punto de venta:', error);
                    this.isLinked = false;
                });
        },
    },
}
</script>
